import { IFetchUserInfo } from '@/shared/types/userInfo';
import { provider } from '.';

export interface UpdatePasswordRequest {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}
export interface UpdateStatusRequest {
  id: number;
  status: number;
}
export interface QuerySelectOptionRequest {
  opR: number; // role_id 判定: 1=大於, 2=小於, 3=等於, 4=in, 84=不檢查role_id, 其他=不查資料
  rIds: number[];
  opO: number; // org_id 判定: 1=大於, 2=小於, 3=等於, 4=in, 84=不檢查org_id, 其他=不查資料
  oIds: number[];
}
export interface QueryUser {
  page: number;
  pageSize: number;
}
export interface UserInfo {
  id: number;
  username: string;
  user_name: string;
  oId: number;
  rId: number;
  pId: number;
}
export interface UserOptionList {
  id: number;
  user_name: string;
  org_id: number;
}

interface Response<T> {
  result?: 'success';
  data: T;
}

// Mock user data
const mockUserData: IFetchUserInfo = {
  id: 1,
  username: 'admin',
  name: 'System Administrator',
  org_id: 1,
  org_type: 1,
  role_id: 1,
  upward: true,
  permissions: [
    {
      permission_id: 1,
      permission_name: 'dashboard:view',
      can_access: true,
      can_edit: true
    },
    {
      permission_id: 2,
      permission_name: 'equipment:view',
      can_access: true,
      can_edit: true
    },
    {
      permission_id: 3,
      permission_name: 'equipment:edit',
      can_access: true,
      can_edit: true
    },
    {
      permission_id: 4,
      permission_name: 'equipment:delete',
      can_access: true,
      can_edit: true
    },
    {
      permission_id: 5,
      permission_name: 'notification:view',
      can_access: true,
      can_edit: true
    },
    {
      permission_id: 6,
      permission_name: 'notification:edit',
      can_access: true,
      can_edit: true
    },
    {
      permission_id: 7,
      permission_name: 'system:view',
      can_access: true,
      can_edit: true
    },
    {
      permission_id: 8,
      permission_name: 'system:edit',
      can_access: true,
      can_edit: true
    },
    {
      permission_id: 9,
      permission_name: 'organization:view',
      can_access: true,
      can_edit: true
    },
    {
      permission_id: 10,
      permission_name: 'position:view',
      can_access: true,
      can_edit: true
    }
    // 若未來 menu 有新增 permissionId，請在此補齊
  ]
};

export const getUserList = async (payload?: QueryUser) =>
  provider.get('/api/users/list', { params: payload }).then((res) => res.data);

export const getUserSelectOptions = (payload: QuerySelectOptionRequest) =>
  provider
    .get('/api/users/getUserSelectOptions', { params: payload })
    .then((res) => res.data);

export const updatePassword = async (payload: UpdatePasswordRequest) =>
  provider.post('/api/users/updatePassword', payload);

export const updateUserStatus = async (payload: UpdateStatusRequest) =>
  provider.post('/api/users/updateStatus', payload);

export const resetPassword = async (payload: UpdateStatusRequest) =>
  provider.post('/api/users/resetPassword', payload);

export const updateUser = async (payload: UserInfo) =>
  provider.post('/api/users/update', payload);

export const addUser = async (payload: UserInfo & { password: string }) =>
  provider.post('/api/users/add', payload);

export const getProfile = async (): Promise<Response<IFetchUserInfo>> => {
  try {
    const response = await provider.get('/api/users/profile');
    return response as unknown as Response<IFetchUserInfo>;
  } catch (error) {
    console.warn('Backend API unavailable, using mock data:', error);
    // Return mock data
    return {
      result: 'success',
      data: mockUserData
    };
  }
};
